import type { BlockDefinition } from '#layers/block-engine/types/block';

export type BuiltinBlockRegistry = Readonly<Record<string, BlockDefinition>>;

let registry: BuiltinBlockRegistry = {};

export function registerBuiltinBlocks(blocks: BuiltinBlockRegistry) {
	registry = blocks;
}

export function getBuiltinBlocks(): BuiltinBlockRegistry {
	return registry;
}
